import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import useStore from "stores/index";

interface Props {
	classroomId: string;
	isActiveClass: boolean;
	hasUnreadMessages: boolean;
	onClick: () => void;
	studentCount: number;
}

const RoomsList = (props: Props): JSX.Element => {
	const { t } = useTranslation();
	const classroom = useStore
		.getState()
		.classroom.getClassrooms()
		.find((classroom) => classroom.sourceId === props.classroomId);
	// @ts-expect-error - Leaving code as it is
	const className = classroom.label || classroom.name;
	const displayName = classroom?.personalisation?.displayName || className;
	return (
		<button className="ClassroomChatroom_rowContainer" data-classid={props.classroomId} onClick={props.onClick} type="button">
			<div className="Classroom_rowWrapper">
				<div className="ClassroomChatroom_classInfo">
					<div className="ClassroomChatroom_name">{displayName}</div>
					{props.isActiveClass ? (
						<span className="ClassroomChatroom_status ClassroomChatroom_active">{`${props.studentCount} student${
							props.studentCount === 1 ? "" : "s"
						}`}</span>
					) : (
						<span className="ClassroomChatroom_status ClassroomChatroom_inactive">{t("classroomChat.classOffline")}</span>
					)}
				</div>
				{!!props.hasUnreadMessages && (
					<div className={clsx("ClassroomChat_notificationsContainer")}>
						<div className="ClassroomChat_notificationsValue"></div>
					</div>
				)}
			</div>
		</button>
	);
};

export default RoomsList;
